module.exports = __webpack_public_path__ + "fonts/NoirPro-Medium.6d74487d.eot";